export default __webpack_public_path__ + "static/media/headshot-ishaan-madan.82b9b8d8.jpeg";